<div class="content-container">
    <h1>BULETIN INFORMATIV</h1><br>

    <p> Nume          ...<b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_prenumePacient)}}...</b>
        Prenume       ...<b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_numePacient)}}...</b>
        Anul nașterii ...<b>{{convertTimestampToDate(getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_dateOfBirthPacient))?.getFullYear()}}...</b>
        Sex M/F       ...<b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_sex) | transloco}}...</b>
    </p>

    <p> Domiciliu:     ...<b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_addrPacient)}}</b>...
    </p>


    <ng-container *ngFor="let entry of bulInfQuestions">
        <p>{{entry.q}}</p>
        <ul>
            <li *ngFor="let answ of entry.answsL1">{{replacePlaceHoldersIn(answ)}}
                 <ul *ngIf="entry.answsL2 && entry.answsL2.length > 0 && answ.hasL2">
                     <li *ngFor="let answL2 of entry.answsL2">
                         {{replacePlaceHoldersIn(answL2)}}
                     </li>
                 </ul>

            </li>
        </ul>
    </ng-container>

    <br><br>
    <p><b>
        Declar că datele furnizate de mine în acest chestionar sunt reale şi complete. Îmi asum întreagă
        responsabilitate pentru incidentele sau complicațiile ce pot să apară în eventualitatea că aceste date sunt
        false sau incomplete.
    </b></p>
    <br>
    <p><b>Datele furnizate de dumneavoastră sunt confidenţiale.</b></p>
    <br>
    <b>
        <table>
            <tr><td style="border: none;">Data:</td> <td style="border: none;">Semnătura pacientului <br>(reprezentant legal):</td></tr>
            <tr><td style="border: none;"> {{getSignedDate()}}</td><td style="border: none;"><div class="max-w-48"><img [src]="getSignatureBlobURL()"></div></td></tr>
        </table>
    </b>
</div>
